import { Injectable } from '@angular/core';
import { WebSocket } from '../web-socket';
import { IPublicSocketService } from './public-socket.interface';

@Injectable({
    providedIn: 'root'
})
export class PublicSocketService extends WebSocket implements IPublicSocketService {}
